import React from 'react';

export type WebsocketContextType = {
  sendWebsocketMessage: (payload: string) => void;
  isWSOpen: boolean;
  isWSClosing: boolean;
};

export const WebsocketContext = React.createContext<WebsocketContextType>({
  sendWebsocketMessage: () => undefined,
  isWSOpen: false,
  isWSClosing: false,
});
